// components/Sidebar.js — MERGE S1 (permission-based + Role Mgmt) + S2 (AI Chat History)
// PATCH: collapsed state diangkat ke DashboardContainer untuk support deep link ?sidebar=hidden
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLang } from '../context/LanguageContext';
import { GROUP_ORDER, GROUP_KEY, groupOf } from '../config/navGroups';
import {
  LayoutDashboard, Cloud, DollarSign, Ticket, Users, Network,
  ChevronRight, Activity, PanelLeftClose, PanelLeftOpen,
  ClipboardList, UserCog, DatabaseZap, ShieldCheck, MessageSquare, Send, MessagesSquare, Database, Link2, Boxes, ScrollText, MonitorSmartphone, KeyRound, CalendarClock, Sparkles, StickyNote, SlidersHorizontal, FileUp, AppWindow, Puzzle, Settings2, NotebookText, Zap, Truck, FileText, Mail, Code2, ShieldAlert, Router, ChevronDown, Receipt, Calculator,
 Menu , FolderOpen, Bell, TrendingUp, Server, Stethoscope } from 'lucide-react';

// permission = key di user.permissions yang diperlukan untuk akses menu ini.
// Admin selalu lolos. Menu tanpa permission = visible ke semua login user.
// labelKey/subKey → diterjemahkan via t(). groupKey → label grup terjemahan.
export const ALL_MENUS = [
  // Dashboard
  { key: 'aws_billing',       permission: 'aws_billing',      labelKey: 'sidebar.awsBilling',       subKey: 'sidebar.awsBilling.sub',       path: '/dashboard/aws-billing',       icon: Cloud,         color: 'text-amber-500',   bgColor: 'bg-amber-50'   },
  { key: 'aws_cost',          permission: 'aws_cost',         labelKey: 'sidebar.awsCost',          subKey: 'sidebar.awsCost.sub',          path: '/dashboard/aws-cost',          icon: DollarSign,    color: 'text-orange-500',  bgColor: 'bg-orange-50'   },
  // AWS Cost Brief sempat tidak terdaftar di sini padahal route dan
  // komponennya ada — jadi hanya bisa dicapai lewat URL langsung.
  { key: 'aws_cost_brief',    permission: 'aws_cost',         labelKey: 'sidebar.awsCostBrief',     subKey: 'sidebar.awsCostBrief.sub',     path: '/dashboard/aws-cost-brief',    icon: Receipt,       color: 'text-amber-600',   bgColor: 'bg-amber-50',   fallback: 'AWS Cost Brief', fallbackSub: 'Ringkasan biaya bulanan' },
  { key: 'aws_inventory',     permission: 'aws_inventory',    labelKey: 'sidebar.awsInventory',     subKey: 'sidebar.awsInventory.sub',     path: '/dashboard/aws-inventory',     icon: Boxes,         color: 'text-cyan-500',    bgColor: 'bg-cyan-50'   },
  { key: 'aws_cloudtrail',    permission: 'aws_cloudtrail',   labelKey: 'sidebar.awsCloudTrail',    subKey: 'sidebar.awsCloudTrail.sub',    path: '/dashboard/aws-cloudtrail',    icon: ScrollText,    color: 'text-rose-500',    bgColor: 'bg-rose-50'   },
  { key: 'aws_pricing',       permission: 'aws_pricing',      labelKey: 'sidebar.awsPricing',       subKey: 'sidebar.awsPricing.sub',       path: '/dashboard/aws-pricing',       icon: Calculator,    color: 'text-emerald-600', bgColor: 'bg-emerald-50', fallback: 'AWS Pricing Calculator', fallbackSub: 'Estimasi biaya & komitmen' },
  { key: 'aws_ec2_health',    permission: 'aws_ec2_health',   labelKey: 'sidebar.awsEc2Health',     subKey: 'sidebar.awsEc2Health.sub',     path: '/dashboard/aws-ec2-health',    icon: Server,        color: 'text-sky-600',     bgColor: 'bg-sky-50', fallback: 'EC2 Health', fallbackSub: 'CPU, RAM, disk per instance' },
  { key: 'solman',            permission: 'solman',           labelKey: 'sidebar.solman',           subKey: 'sidebar.solman.sub',           path: '/dashboard/solman',            icon: Ticket,        color: 'text-brand-500',    bgColor: 'bg-brand-50'   },
  { key: 'solman_docs',       permission: 'solman_docs',      labelKey: 'sidebar.solman_docs',      subKey: 'sidebar.solman_docs.sub',      path: '/dashboard/solman-docs',       icon: FolderOpen,    color: 'text-indigo-600',  bgColor: 'bg-indigo-50', fallback: 'Solman Documents', fallbackSub: 'Project document download' },
  { key: 'sap_usage',         permission: 'sap_usage',        labelKey: 'sidebar.sapUsage',         subKey: 'sidebar.sapUsage.sub',         path: '/dashboard/sap-usage',         icon: Users,         color: 'text-emerald-500', bgColor: 'bg-emerald-50'   },
  { key: 'sap_user_mgmt',     permission: 'sap_user_mgmt',    labelKey: 'sidebar.sapUserMgmt',      subKey: 'sidebar.sapUserMgmt.sub',      path: '/dashboard/sap-user-maintenance', icon: KeyRound,   color: 'text-violet-500',  bgColor: 'bg-violet-50', fallback: 'SAP User Maintenance', fallbackSub: 'Lock / unlock / reset password' },
  { key: 'sap_roles',         permission: 'sap_roles',        labelKey: 'sidebar.sapRoles',         subKey: 'sidebar.sapRoles.sub',         path: '/dashboard/sap-roles',         icon: ShieldCheck, color: 'text-fuchsia-500', bgColor: 'bg-fuchsia-50', fallback: 'SAP Role Maintenance', fallbackSub: 'Audit role & assignment (read-only)' },
  { key: 'sap_basis_mon',     permission: 'sap_basis_mon',    labelKey: 'sidebar.sapBasisMon',      subKey: 'sidebar.sapBasisMon.sub',      path: '/dashboard/sap-basis',         icon: Activity,   color: 'text-teal-500',    bgColor: 'bg-teal-50', fallback: 'SAP Basis Monitor',    fallbackSub: 'Health: job, lock, WP, sistem' },
  { key: 'sap_logon_audit',   permission: 'sap_logon_audit',  labelKey: 'sidebar.sapLogonAudit',    subKey: 'sidebar.sapLogonAudit.sub',    path: '/dashboard/sap-logon-audit',   icon: ShieldAlert, color: 'text-red-500',    bgColor: 'bg-red-50', fallback: 'External Access Audit', fallbackSub: 'Akses SAP dari luar jaringan' },
  { key: 'linux_login_audit', permission: 'linux_login_audit', labelKey: 'sidebar.linuxLoginAudit', subKey: 'sidebar.linuxLoginAudit.sub', path: '/dashboard/linux-login-audit', icon: ShieldCheck, color: 'text-emerald-600', bgColor: 'bg-emerald-50', fallback: 'Linux Login Audit', fallbackSub: 'SSH logins on all Linux EC2' },
  { key: 'sap_router_log',    permission: 'sap_router_log',   labelKey: 'sidebar.sapRouterLog',     subKey: 'sidebar.sapRouterLog.sub',     path: '/dashboard/sap-router-log',    icon: Router,     color: 'text-amber-600',  bgColor: 'bg-amber-50', fallback: 'SAProuter Log', fallbackSub: 'Koneksi masuk & IP publik asal' },
  { key: 'sap_config',        permission: 'sap_customizing',  labelKey: 'sidebar.sapConfig',        subKey: 'sidebar.sapConfig.sub',        path: '/dashboard/sap-config',        icon: Settings2,  color: 'text-amber-500',   bgColor: 'bg-amber-50',  fallback: 'SAP Configuration', fallbackSub: 'SPRO / IMG customizing' },
  { key: 'sap_customizing',   permission: 'sap_customizing',  hideIfPerm: 'sap_source', labelKey: 'sidebar.sapCustomizing',   subKey: 'sidebar.sapCustomizing.sub',   path: '/dashboard/sap-customizing',   icon: Puzzle,     color: 'text-indigo-500',  bgColor: 'bg-indigo-50', fallback: 'SAP Customizing', fallbackSub: 'User exit, BAdI & enhancement' },
  { key: 'sap_source',        permission: 'sap_source',       labelKey: 'sidebar.sapSource',        subKey: 'sidebar.sapSource.sub',        path: '/dashboard/sap-source',        icon: Code2,      color: 'text-sky-500',     bgColor: 'bg-sky-50',    fallback: 'ABAP Workbench', fallbackSub: 'Custom source, dictionary, classes & enhancements' },
  { key: 'transport',         permission: 'transport',        labelKey: 'sidebar.transport',        subKey: 'sidebar.transport.sub',        path: '/dashboard/transport',         icon: Truck,      color: 'text-lime-600',    bgColor: 'bg-lime-50', fallback: 'SAP Transport Request', fallbackSub: 'STMS queue & import Q01/P01' },
  { key: 'sap_notes',         permission: 'sap_notes',               labelKey: 'sidebar.sapNotes',         subKey: 'sidebar.sapNotes.sub',         path: '/dashboard/sap-notes',         icon: FileText,   color: 'text-brand-600',    bgColor: 'bg-brand-50', fallback: 'SAP Note', fallbackSub: 'Katalog, arsip & tracking note' },
  // Infra
  { key: 'm365',              permission: 'm365_license',     labelKey: 'sidebar.m365',             subKey: 'sidebar.m365.sub',             path: '/dashboard/m365',              icon: AppWindow,     color: 'text-sky-500',     bgColor: 'bg-sky-50', fallback: 'M365 License', fallbackSub: 'Ringkasan lisensi Microsoft 365' },
  { key: 'sdp',               permission: 'sdp',              labelKey: 'sidebar.sdp',              subKey: 'sidebar.sdp.sub',              path: '/dashboard/sdp',               icon: Ticket,        color: 'text-orange-500',  bgColor: 'bg-orange-50', fallback: 'SDP Cloud', fallbackSub: 'ManageEngine ticketing & asset' },
  { key: 'netmap',               permission: 'netmap',              labelKey: 'sidebar.netmap',              subKey: 'sidebar.netmap.sub',              path: '/dashboard/network-topology',               icon: Network,        color: 'text-orange-500',  bgColor: 'bg-orange-50', fallback: 'Network Topology', fallbackSub: 'Site network diagrams' },
  { key: 'pc_health',         permission: 'pc_health',        labelKey: 'sidebar.pcHealth',         subKey: 'sidebar.pcHealth.sub',         path: '/dashboard/pc-health',         icon: Stethoscope,   color: 'text-indigo-500',  bgColor: 'bg-indigo-50', fallback: 'PC Health', fallbackSub: 'On-demand PC troubleshooting' },
  // HR pages
  { key: 'employee_overtime', permission: 'employee_overtime', labelKey: 'sidebar.employeeOvertime', subKey: 'sidebar.employeeOvertime.sub', path: '/dashboard/employee-overtime', icon: CalendarClock, color: 'text-amber-500', bgColor: 'bg-amber-50', fallback: 'Employee Overtime', fallbackSub: 'Data lembur karyawan' },
  // Admin pages
  { key: 'logs',              permission: 'logs',             labelKey: 'sidebar.logs',             subKey: 'sidebar.logs.sub',             path: '/dashboard/logs',              icon: ClipboardList, color: 'text-slate-500',   bgColor: 'bg-slate-50' },
  { key: 'stock_watchlist',   permission: 'stock_watchlist',  labelKey: 'sidebar.stockWatchlist',   subKey: 'sidebar.stockWatchlist.sub',   path: '/dashboard/stock-watchlist',   icon: TrendingUp,    color: 'text-emerald-500', bgColor: 'bg-emerald-50', fallback: 'Stock Watchlist', fallbackSub: 'IDX prices (Yahoo, delayed)' },
  { key: 'claude_activity',   permission: 'claude_activity',  labelKey: 'sidebar.claudeActivity',   subKey: 'sidebar.claudeActivity.sub',   path: '/dashboard/claude-activity',   icon: Sparkles,      color: 'text-orange-500',  bgColor: 'bg-orange-50', fallback: 'Claude Activity', fallbackSub: 'Member usage of Claude (OTel)' },
  { key: 'ai_history',        permission: 'ai_history',       labelKey: 'sidebar.aiHistory',        subKey: 'sidebar.aiHistory.sub',        path: '/dashboard/ai-history',        icon: MessageSquare, color: 'text-indigo-500',  bgColor: 'bg-indigo-50' },
  { key: 'ai_datasources',    permission: 'ai_config',        labelKey: 'sidebar.aiDataSources',    subKey: 'sidebar.aiDataSources.sub',    path: '/dashboard/ai-datasources',    icon: Database,      color: 'text-brand-500',    bgColor: 'bg-brand-50', fallback: 'AI Data Sources', fallbackSub: 'Kelola data untuk AI' },
  { key: 'ai_config_settings', permission: 'ai_settings',     labelKey: 'sidebar.aiConfig',         subKey: 'sidebar.aiConfig.sub',         path: '/dashboard/ai-config',         icon: SlidersHorizontal, color: 'text-indigo-500', bgColor: 'bg-indigo-50', fallback: 'AI Configuration', fallbackSub: 'Provider, model & API key' },
  { key: 'ai_workspace',      permission: 'ai_workspace',     labelKey: 'sidebar.aiWorkspace',      subKey: 'sidebar.aiWorkspace.sub',      path: '/dashboard/ai-workspace',      icon: Sparkles,      color: 'text-indigo-500',  bgColor: 'bg-indigo-50', fallback: 'AI Workspace', fallbackSub: 'Chat AI halaman penuh' },
  { key: 'ai_coding',         permission: 'ai_coding',        labelKey: 'sidebar.aiCoding',         subKey: 'sidebar.aiCoding.sub',         path: '/dashboard/ai-coding',         icon: Code2,         color: 'text-emerald-500', bgColor: 'bg-emerald-50', fallback: 'AI Coding', fallbackSub: 'Asisten coding + tool use' },
  { key: 'ai_actions',        permission: 'ai_actions',       labelKey: 'sidebar.aiActions',        subKey: 'sidebar.aiActions.sub',        path: '/dashboard/ai-actions',        icon: Zap,           color: 'text-violet-500',  bgColor: 'bg-violet-50', fallback: 'AI Actions', fallbackSub: 'Aksi bahasa natural + approval' },
  { key: 'users',             permission: 'users',            labelKey: 'sidebar.users',            subKey: 'sidebar.users.sub',            path: '/dashboard/users',             icon: UserCog,       color: 'text-violet-500',  bgColor: 'bg-violet-50' },
  { key: 'roles',             permission: 'role_management',  labelKey: 'sidebar.roles',            subKey: 'sidebar.roles.sub',            path: '/dashboard/roles',             icon: ShieldCheck,   color: 'text-indigo-500',  bgColor: 'bg-indigo-50' },
  { key: 'table_maintenance', permission: 'table_maintenance',labelKey: 'sidebar.tableMaintenance', subKey: 'sidebar.tableMaintenance.sub', path: '/dashboard/table-maintenance', icon: DatabaseZap,   color: 'text-rose-500',    bgColor: 'bg-rose-50' },
  { key: 'monthly_report',    permission: 'monthly_report',   labelKey: 'sidebar.monthlyReport',    subKey: 'sidebar.monthlyReport.sub',    path: '/dashboard/monthly-report',    icon: Mail,          color: 'text-orange-500',  bgColor: 'bg-orange-50', fallback: 'Monthly Report', fallbackSub: 'Laporan bulanan otomatis' },
  { key: 'telegram',          permission: 'telegram',         labelKey: 'sidebar.telegram',         subKey: 'sidebar.telegram.sub',         path: '/dashboard/telegram',          icon: Send,          color: 'text-sky-500',     bgColor: 'bg-sky-50' },
  { key: 'telegram_log',      permission: 'telegram_log',     labelKey: 'sidebar.telegramLog',      subKey: 'sidebar.telegramLog.sub',      path: '/dashboard/telegram-log',      icon: MessagesSquare, color: 'text-cyan-500',    bgColor: 'bg-cyan-50' },
  { key: 'notif_history',     permission: '__admin__',        labelKey: 'sidebar.notifHistory',     subKey: 'sidebar.notifHistory.sub',     path: '/dashboard/notification-history', icon: Bell,       color: 'text-brand-600',   bgColor: 'bg-brand-50', fallback: 'Notification History', fallbackSub: 'All push notifications sent' },
  { key: 'share_links',       permission: '__admin__',        labelKey: 'sidebar.shareLinks',       subKey: 'sidebar.shareLinks.sub',       path: '/dashboard/share-links',       icon: Link2,         color: 'text-teal-500',    bgColor: 'bg-teal-50', fallback: 'Share Links', fallbackSub: 'Link publik read-only' },
  { key: 'sessions',          permission: '__admin__',        labelKey: 'sidebar.sessions',         subKey: 'sidebar.sessions.sub',         path: '/dashboard/sessions',          icon: MonitorSmartphone, color: 'text-emerald-500', bgColor: 'bg-emerald-50', fallback: 'Session Log', fallbackSub: 'Sesi login aktif & force-logout' },
  { key: 'file_deploy',       permission: '__admin__',        labelKey: 'sidebar.fileDeploy',       subKey: 'sidebar.fileDeploy.sub',       path: '/dashboard/file-deploy',       icon: FileUp,        color: 'text-indigo-500',  bgColor: 'bg-indigo-50', fallback: 'File Deploy', fallbackSub: 'Upload & deploy file .js/.jsx' },
  { key: 'notes',             permission: 'notes',            labelKey: 'sidebar.notes',            subKey: 'sidebar.notes.sub',            path: '/dashboard/notes',             icon: StickyNote,    color: 'text-amber-500',   bgColor: 'bg-amber-50', fallback: 'Notes', fallbackSub: 'Catatan & memo tim' },
  { key: 'notes_plain',       permission: 'notes_plain',      labelKey: 'sidebar.notesPlain',       subKey: 'sidebar.notesPlain.sub',       path: '/dashboard/notes-plain',       icon: NotebookText,  color: 'text-lime-600',    bgColor: 'bg-lime-50', fallback: 'Notes Plain', fallbackSub: 'Catatan tanpa indeks RAG' },
];


const MIN_WIDTH       = 180;
const MAX_WIDTH       = 360;
const DEFAULT_WIDTH   = 252;
const COLLAPSED_WIDTH = 64;

// ── Default auto-hide berdasarkan cara-masuk ────────────────────────────────
//   • Masuk via deep-link sub-halaman dashboard (mis. /dashboard/aws-cost) → ON   [skenario 3]
//   • Masuk via pintu depan ("/", "/login") → login → mendarat di /dashboard → device-based
//        - mobile  → ON   [skenario 1]
//        - desktop → OFF  [skenario 2]
//
// Keputusan "masuk via deep-link" DISIMPAN di sessionStorage saat dokumen
// pertama kali load. Ini penting karena alur login bisa memicu redirect ke
// /login atau full reload — kalau hanya mengandalkan konstanta di memori,
// nilainya hilang dan jatuh ke device-based. Flag hanya di-SET (tidak pernah
// dihapus di tengah), jadi bertahan sepanjang sesi tab.
//
// "/dashboard" polos (Overview, tujuan login normal) TIDAK dihitung deep-link —
// hanya sub-halaman seperti /dashboard/aws-cost, /dashboard/solman, dst.
const DEEPLINK_KEY = 'sb_deeplink_entry';
const CLOSED_GROUPS_KEY = 'sb_closed_groups';

if (typeof window !== 'undefined' && /^\/dashboard\/.+/.test(window.location.pathname)) {
  try { sessionStorage.setItem(DEEPLINK_KEY, '1'); } catch { /* abaikan (private mode) */ }
}

function enteredViaDeepLink() {
  if (typeof window === 'undefined') return false;
  try { return sessionStorage.getItem(DEEPLINK_KEY) === '1'; } catch { return false; }
}

// Deteksi mobile browser: pakai UA-CH kalau ada, fallback ke UA regex +
// pointer kasar + lebar layar. Tahan banting di lingkungan tanpa window.
function detectMobileBrowser() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
    return navigator.userAgentData.mobile;
  }
  const ua       = navigator.userAgent || '';
  const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const coarse   = typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
  const narrow   = window.innerWidth <= 768;
  return uaMobile || (coarse && narrow);
}

// Nilai awal auto-hide:
//   • desktop             → OFF             [selalu, tanpa pengecualian]
//   • mobile deep-link    → ON              [skenario 3]
//   • mobile login normal → ON              [skenario 1]
// Autohide hanya berlaku untuk mobile browser.
const IS_MOBILE_BROWSER = detectMobileBrowser();

function getInitialAutoHide() {
  if (!IS_MOBILE_BROWSER) return false;
  return true; // mobile: selalu ON (deep-link maupun login normal)
}

// ── Props:
//   collapsed        {boolean}  — dikontrol oleh DashboardContainer (dari URL ?sidebar=hidden)
//   onToggleCollapse {function} — callback toggle collapse ke parent
//
// Semua fitur lain (resize, auto-hide, drag) tetap berfungsi secara lokal.
export default function Sidebar({ collapsed = false, onToggleCollapse }) {
  const { user }   = useAuth();
  const { t }      = useLang();
  const location   = useLocation();

  const [width, setWidth]           = useState(DEFAULT_WIDTH);
  const [isHovered, setIsHovered]   = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [autoHide, setAutoHide]     = useState(getInitialAutoHide);
  // Grup yang sedang dilipat, disimpan sebagai array key di localStorage.
  // Yang disimpan adalah grup TERTUTUP, bukan yang terbuka: dengan begitu grup
  // baru yang ditambahkan nanti muncul terbuka secara bawaan, bukan
  // tersembunyi karena tidak ada dalam daftar lama.
  const [closedGroups, setClosedGroups] = useState(() => {
    try {
      const raw = localStorage.getItem(CLOSED_GROUPS_KEY);
      return new Set(raw ? JSON.parse(raw) : []);
    } catch { return new Set(); }
  });

  const sidebarRef = useRef(null);
  const startXRef  = useRef(0);
  const startWRef  = useRef(0);
  const hideTimer  = useRef(null);

  const userPerms = Array.isArray(user?.permissions) ? user.permissions : [];
  const isAdmin   = user?.role === 'admin';

  // Permission-based filter: admin lihat semua, menu tanpa permission (null)
  // tampil ke semua user login, role lain hanya yang ada di permissions.
  const visibleMenus = ALL_MENUS.filter(m =>
    (isAdmin || !m.permission || userPerms.includes(m.permission)) && !(m.hideIfPerm && (isAdmin || userPerms.includes(m.hideIfPerm)))
  );

  // Grup diambil dari navGroups, bukan dari field pada tiap menu. Urutannya
  // mengikuti GROUP_ORDER supaya penambahan satu menu tidak diam-diam
  // memindahkan posisi grupnya — dulu urutan grup ditentukan oleh menu mana
  // yang kebetulan muncul lebih dulu di ALL_MENUS.
  const menusByGroup = {};
  visibleMenus.forEach(m => {
    const g = groupOf(m.key);
    (menusByGroup[g] = menusByGroup[g] || []).push(m);
  });
  const groups = GROUP_ORDER.filter(g => menusByGroup[g]?.length);

  const showSidebar = useCallback(() => { clearTimeout(hideTimer.current); setIsHovered(true); }, []);
  const hideSidebar = useCallback(() => {
    if (!autoHide) return;
    hideTimer.current = setTimeout(() => setIsHovered(false), 300);
  }, [autoHide]);

  useEffect(() => () => clearTimeout(hideTimer.current), []);

  useEffect(() => {
    try { localStorage.setItem(CLOSED_GROUPS_KEY, JSON.stringify([...closedGroups])); }
    catch { /* private mode: lipatannya jadi sesi-saja, bukan galat */ }
  }, [closedGroups]);

  const toggleGroup = useCallback((g) => {
    setClosedGroups(prev => {
      const next = new Set(prev);
      if (next.has(g)) next.delete(g); else next.add(g);
      return next;
    });
  }, []);

  // ── Resize drag handle ─────────────────────────────────────────────────────
  const onMouseDown = (e) => {
    e.preventDefault();
    startXRef.current = e.clientX;
    startWRef.current = width;
    setIsDragging(true);
  };

  useEffect(() => {
    if (!isDragging) return;
    const onMove = (e) => {
      const delta    = e.clientX - startXRef.current;
      const newWidth = Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, startWRef.current + delta));
      setWidth(newWidth);
      // Drag ke kiri sampai batas → auto-collapse via parent callback
      if (newWidth < MIN_WIDTH + 20 && !collapsed) onToggleCollapse?.();
      else if (newWidth >= MIN_WIDTH + 20 && collapsed) onToggleCollapse?.();
    };
    const onUp = () => setIsDragging(false);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    return () => { window.removeEventListener('mousemove', onMove); window.removeEventListener('mouseup', onUp); };
  }, [isDragging, collapsed, onToggleCollapse]);

  // ── Tombol collapse: saat expand kembali, reset width ke default ──────────
  const handleToggle = useCallback(() => {
    if (collapsed) setWidth(DEFAULT_WIDTH); // expand → reset lebar
    onToggleCollapse?.();
  }, [collapsed, onToggleCollapse]);

  const sidebarWidth = collapsed ? COLLAPSED_WIDTH : width;
  const isVisible    = !autoHide || isHovered;

  return (
    <>
      {autoHide && !isHovered && (
        <div className="fixed left-0 top-0 h-full w-3 z-40" onMouseEnter={showSidebar} />
      )}

      <aside
        ref={sidebarRef}
        onMouseEnter={showSidebar}
        onMouseLeave={hideSidebar}
        className="flex flex-col bg-white border-r border-slate-100 relative z-30 flex-shrink-0"
        style={{
          width: sidebarWidth,
          height: '100vh',
          transition: isDragging ? 'none' : 'width 0.25s ease, transform 0.25s ease',
          transform: autoHide && !isVisible ? `translateX(-${sidebarWidth}px)` : 'translateX(0)',
          position: autoHide ? 'fixed' : 'sticky',
          top:    0,
          left:   autoHide ? 0 : undefined,
          alignSelf: autoHide ? undefined : 'flex-start',
        }}
      >
        {/* Brand */}
        <div className={`flex items-center gap-3 px-4 py-5 border-b border-slate-100 ${collapsed ? 'justify-center px-2' : ''}`}>
          <div className="flex-shrink-0 w-9 h-9 bg-brand-600 rounded-xl flex items-center justify-center shadow-md">
            <LayoutDashboard style={{ width: 18, height: 18 }} className="text-white" />
          </div>
          {!collapsed && (
            <div className="overflow-hidden">
              <div className="font-display font-bold text-slate-800 text-sm leading-tight">{t('sidebar.brand')}</div>
              <div className="text-xs text-slate-400 font-medium">{t('sidebar.brandSub')}</div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-3 mt-2 pb-4 overflow-y-auto nav-scroll">
          <div className={`flex mb-1 ${collapsed ? 'justify-center' : 'justify-start'}`}>
            <button
              onClick={handleToggle}
              title={collapsed ? t('sidebar.expand') : t('sidebar.collapse')}
              className="w-8 h-8 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 hover:text-brand-600 hover:bg-slate-50 shadow-sm transition-all"
            >
              {collapsed
                ? <Menu style={{ width: 16, height: 16 }} />
                : <ChevronRight style={{ width: 14, height: 14 }} className="rotate-180" />}
            </button>
          </div>
          <NavLink to="/dashboard" end
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 cursor-pointer mb-1
              ${isActive ? 'bg-brand-600 text-white' : 'text-slate-600 hover:bg-brand-50 hover:text-brand-700'}
              ${collapsed ? 'justify-center px-2' : ''}`
            }
            title={collapsed ? t('sidebar.overview') : ''}
          >
            <Activity style={{ width: 18, height: 18 }} className="flex-shrink-0" />
            {!collapsed && <span>{t('sidebar.overview')}</span>}
            {!collapsed && <ChevronRight style={{ width: 14, height: 14 }} className="ml-auto opacity-30" />}
          </NavLink>

          {groups.map(group => {
            const items = menusByGroup[group];
            // Grup yang memuat halaman aktif SELALU terbuka, apa pun yang
            // tersimpan. Melipat grup lalu berpindah ke halaman di dalamnya
            // akan membuat menu aktif tak terlihat — pengguna kehilangan
            // penanda "saya sedang di mana", dan itu lebih merugikan daripada
            // menghormati lipatan yang tersimpan.
            const hasActive = items.some(m =>
              location.pathname === m.path || location.pathname.startsWith(m.path + '/'));
            // Saat collapsed, sidebar hanya menampilkan ikon — tidak ada header
            // grup yang bisa diklik, jadi melipat akan menyembunyikan menu
            // tanpa cara membukanya kembali.
            const isClosed = !collapsed && !hasActive && closedGroups.has(group);
            const label = t(GROUP_KEY[group] || group);
            return (
            <div key={group} className="mt-4">
              {!collapsed && (
                <button
                  type="button"
                  onClick={() => toggleGroup(group)}
                  aria-expanded={!isClosed}
                  title={label}
                  className="w-full flex items-center gap-1.5 text-xs font-semibold text-slate-400 hover:text-slate-600 uppercase tracking-wider px-3 mb-2 transition-colors"
                >
                  <ChevronDown
                    style={{ width: 13, height: 13, transition: 'transform .15s ease',
                      transform: isClosed ? 'rotate(-90deg)' : 'none' }}
                    className="flex-shrink-0" />
                  <span className="truncate">{label}</span>
                  <span className="ml-auto tabular-nums text-slate-300 font-normal">{items.length}</span>
                </button>
              )}
              {collapsed && <div className="border-t border-slate-100 my-2" />}

              {(isClosed ? [] : items).map(menu => {
                const Icon     = menu.icon;
                const isActive = location.pathname === menu.path ||
                  (menu.path !== '/dashboard' && location.pathname.startsWith(menu.path));
                return (
                  <NavLink key={menu.key} to={menu.path}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 cursor-pointer mb-1
                      ${isActive ? 'bg-brand-600 text-white' : 'text-slate-600 hover:bg-brand-50 hover:text-brand-700'}
                      ${collapsed ? 'justify-center px-2' : ''}`
                    }
                    title={collapsed ? (t(menu.labelKey) === menu.labelKey && menu.fallback ? menu.fallback : t(menu.labelKey)) : ''}
                  >
                    <div className={`flex-shrink-0 w-7 h-7 rounded-lg flex items-center justify-center transition-all
                      ${isActive ? 'bg-white/20' : menu.bgColor}`}>
                      <Icon className={isActive ? 'text-white' : menu.color} style={{ width: 14, height: 14 }} />
                    </div>
                    {!collapsed && (
                      <div className="flex-1 overflow-hidden">
                        <div className="text-sm font-medium leading-tight truncate">{t(menu.labelKey) === menu.labelKey && menu.fallback ? menu.fallback : t(menu.labelKey)}</div>
                        <div className={`text-xs truncate ${isActive ? 'text-brand-200' : 'text-slate-400'}`}>{t(menu.subKey) === menu.subKey && menu.fallbackSub ? menu.fallbackSub : t(menu.subKey)}</div>
                      </div>
                    )}
                    {!collapsed && !isActive && <ChevronRight style={{ width: 14, height: 14 }} className="ml-auto opacity-30 flex-shrink-0" />}
                  </NavLink>
                );
              })}
            </div>
            );
          })}
        </nav>

        {/* Kontrol collapse & auto-hide — dipindah ke footer supaya bagian atas
            sidebar langsung menampilkan menu, bukan dua baris pengaturan. */}
        <div className={`flex-shrink-0 px-3 py-2 border-t border-slate-100 flex gap-1 ${collapsed ? 'flex-col items-center' : 'items-center'}`}>
          {/* Tombol collapse/expand — memanggil handleToggle (ke parent) */}
          <button
            onClick={handleToggle}
            title={collapsed ? t('sidebar.expand') : t('sidebar.collapse')}
            className={`flex items-center gap-2 px-3 py-2 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-xl text-xs font-medium transition-all ${collapsed ? 'justify-center w-auto' : 'flex-1'}`}
          >
            {collapsed
              ? <PanelLeftOpen style={{ width: 16, height: 16 }} />
              : <><PanelLeftClose style={{ width: 16, height: 16 }} /><span>{t('sidebar.collapse')}</span></>
            }
          </button>

          {/* Auto-hide toggle — hanya fungsional di mobile; desktop: tampil abu-abu non-interaktif */}
          <button
            onClick={() => { if (IS_MOBILE_BROWSER) { setAutoHide(p => !p); setIsHovered(true); } }}
            title={`${t('sidebar.autoHide')} (${autoHide ? t('sidebar.autoHide.on') : t('sidebar.autoHide.off')})`}
            className={`flex items-center justify-center gap-2 px-2.5 py-2 rounded-xl text-xs font-medium transition-all flex-shrink-0
              ${!IS_MOBILE_BROWSER ? 'opacity-40 cursor-not-allowed text-slate-400' :
                autoHide ? 'bg-brand-50 text-brand-600' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-50'}`}
          >
            <span className={`w-2 h-2 rounded-full flex-shrink-0 ${autoHide ? 'bg-brand-500' : 'bg-slate-300'}`} />
            {!collapsed && <span className="whitespace-nowrap">{t('sidebar.autoHide')}</span>}
          </button>
        </div>


        {/* Resize Handle */}
        {!collapsed && (
          <div onMouseDown={onMouseDown}
            className="absolute right-0 top-0 h-full w-1.5 cursor-col-resize group z-50"
            style={{ right: -2 }}>
            <div className={`h-full w-full transition-colors ${isDragging ? 'bg-brand-500' : 'bg-transparent group-hover:bg-brand-300'}`} />
          </div>
        )}
      </aside>

      {autoHide && <div style={{ width: 0, flexShrink: 0 }} />}
      {autoHide && isVisible && (
        <div className="fixed inset-0 z-20 bg-black/10" onClick={() => setIsHovered(false)} />
      )}
      {isDragging && <style>{`* { cursor: col-resize !important; user-select: none; }`}</style>}
    </>
  );
}
